import React from 'react';
import { AwardIcon, StarIcon } from 'lucide-react';
export const CredibilitySection = () => {
  const achievements = ["5 Ballon d'Or awards", '4 European Golden Shoes', 'Champions League titles with multiple clubs', 'Recognized by FIFA and UEFA as one of the greatest of all time'];
  return <div className="bg-white py-16" data-id="element-15">
      <div className="container mx-auto px-4" data-id="element-16">
        <h2 className="text-3xl font-bold text-center mb-4" data-id="element-17">Credible Proof</h2>
        <p className="text-center mb-12 text-gray-700 max-w-2xl mx-auto" data-id="element-18">
          Cristiano Ronaldo's career achievements speak for themselves:
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-19">
          {achievements.map((achievement, index) => <div key={index} className="bg-gray-50 p-6 rounded-lg text-center" data-id="element-20">
              <div className="flex justify-center mb-4" data-id="element-21">
                {index % 2 === 0 ? <AwardIcon className="h-8 w-8 text-yellow-500" data-id="element-22" /> : <StarIcon className="h-8 w-8 text-yellow-500" data-id="element-23" />}
              </div>
              <p className="text-gray-800" data-id="element-24">{achievement}</p>
            </div>)}
        </div>
        <div className="mt-10 text-center" data-id="element-25">
          <p className="text-lg text-gray-700" data-id="element-26">
            His legacy has already been etched into football history. This
            edition simply preserves it in the form true collectors demand.
          </p>
        </div>
      </div>
    </div>;
};